export const FEATURE_CONSTANTS = [
  {
    label: {
      key: 'planList.pages',
      fallback: 'PAGES',
    },
    premium: {
      key: 'planList.unlimited',
      fallback: 'Unlimited',
      comingSoon: null,
    },
    free: {
      key: 'planList.upTo',
      fallback: '1 Shared Page',
    },
  },
  {
    label: {
      key: 'planList.storage',
      fallback: 'STORAGE',
    },
    premium: {
      key: 'planList.unlimited',
      fallback: 'Unlimited',
      comingSoon: null,
    },
    free: {
      key: 'planList.availableSpace',
      fallback: '2 GB',

    },
  },
  {
    label: {
      key: 'planList.resume.feature',
      fallback: 'RESUME',
    },
    premium: {
      key: 'planList.resume.sharing',
      fallback: 'Resume Sharing',
      comingSoon: null,
    },
    free: {
      key: 'planList.resume.build',
      fallback: 'Resume Build Only',
    },
  },
  {
    label: {
      key: 'planList.resource.library',
      fallback: 'RESOURCE LIBRARY',
    },
    premium: {
      key: 'planList.resource.plus',
      fallback: '1000+ templates and resources',
      comingSoon: null,
    },
    free: {
      key: 'planList.resource.free',
      fallback: 'Access to guides and examples',
    },
  },
  {
    label: {
      key: 'planList.collections',
      fallback: 'COLLECTIONS',
    },
    premium: {
      key: 'icon',
      fallback: null,
      comingSoon: null,
    },
    free: {
      key: 'icon',
      fallback: null,
    },
  },
  {
    label: {
      key: 'planList.groups',
      fallback: 'GROUPS',
    },
    premium: {
      key: 'icon',
      fallback: null,
      comingSoon: null,
    },
    free: {
      key: 'icon',
      fallback: null,
    },
  },
  {
    label: {
      key: 'planList.commenting',
      fallback: 'COMMENTING',
    },
    premium: {
      key: 'icon',
      fallback: null,
      comingSoon: null,
    },
    free: {
      key: 'icon',
      fallback: null,
    },
  },
  {
    label: {
      key: 'planList.google.integration',
      fallback: 'Presentation Mode',
    },
    premium: {
      key: 'icon',
      fallback: null,
      comingSoon: null,
    },
    free: {
      key: 'icon',
      fallback: null,
    },
  },
  {
    label: {
      key: 'planList.google.classroom',
      fallback: 'GOOGLE DRIVE & MICROSOFT INTEGRATION',
    },
    premium: {
      key: 'icon',
      fallback: null,
      comingSoon: null,
    },
    free: {
      key: 'icon',
      fallback: null,
    },
  },
  {
    label: {
      key: 'planList.templates',
      fallback: 'TEMPLATES',
    },
    premium: {
      key: 'icon',
      fallback: null,
      comingSoon: null,
    },
    free: {
      key: null,
      fallback: null,
    },
  },
  {
    label: {
      key: 'planList.multimedia',
      fallback: null,
    },
    premium: {
      key: 'icon',
      fallback: null,
      comingSoon: null,
    },
    free: {
      key: null,
      fallback: null,

    },
  },
  {
    label: {
      key: 'planList.assignments',
      fallback: 'Assignments',
    },
    premium: {
      key: 'icon',
      fallback: null,
      comingSoon: null,
    },
    free: {
      key: null,
      fallback: null,
    },
  },
];
